(function () {
    'use strict';
    angular.module('doclr.beschikbaarheidrelation', []);
})();